import React from 'react';
import { Calculator, FileText, Gift, Home, PiggyBank } from 'lucide-react';

/**
 * Datos de navegación reales (misma copy que ES.json: user.dashboard.myBenefit,
 * etc.), compartidos entre Sidebar (desktop) y MobileBottomNav (móvil) —
 * en su propio fichero para que SidebarNav y SidebarNavItem puedan importarlo
 * los dos sin depender uno del otro (evita el import circular entre ambos).
 *
 * COMPUESTO A PROPÓSITO — en el código real (Dashboard.tsx) "Plan de Empleo"
 * y "Simuladores"/"Invita y gana" no salen NUNCA juntos: son dos `userTabs`
 * distintos según `showIndividualTabs` (empleado con plan de empresa vs.
 * individual/autónomo). Aquí se listan todos en un único array — más simple
 * para navegar el Storybook, a costa de no ser 100% fiel a que un usuario
 * real solo ve un subconjunto según su perfil.
 */
export interface NavItemData {
	route: string;
	label: string;
	icon: React.ReactNode;
}

export const NAV_ITEMS: NavItemData[] = [
	{ route: 'my-benefit', label: 'Mi beneficio', icon: <Home className="w-6 h-6" /> },
	{ route: 'my-contributions', label: 'Movimientos', icon: <PiggyBank className="w-6 h-6" /> },
	{
		route: 'employment-pension-plan',
		label: 'Plan de Empleo',
		icon: <FileText className="w-6 h-6" />
	},
	{ route: 'simulators', label: 'Simuladores', icon: <Calculator className="w-6 h-6" /> },
	// Solo en userTabs individual/autónomo (user.dashboard.myReferrals) — ver nota arriba.
	{ route: 'my-referrals', label: 'Invita y gana', icon: <Gift className="w-6 h-6" /> }
];
